import { Component, output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgIcon } from '@ng-icons/core';
import { Button } from 'excellence-ui';

@Component({
  selector: 'app-energy-interface-list-no-results',
  imports: [NgIcon, Button, TranslocoPipe],
  templateUrl: './energy-interface-list-no-results.html',
})
export class EnergyInterfaceListNoResults {
  clickReset = output();
}
